/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Closed_NoticeInputs */

const en_settings_tickets_closed_notice = /** @type {(inputs: Settings_Tickets_Closed_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This ticket is closed. Create a new ticket if you need further help.`)
};

const zh_settings_tickets_closed_notice = /** @type {(inputs: Settings_Tickets_Closed_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该工单已关闭,如需进一步帮助请提交新工单。`)
};

/**
* | output |
* | --- |
* | "This ticket is closed. Create a new ticket if you need further help." |
*
* @param {Settings_Tickets_Closed_NoticeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_closed_notice = /** @type {((inputs?: Settings_Tickets_Closed_NoticeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Closed_NoticeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_closed_notice(inputs)
	return zh_settings_tickets_closed_notice(inputs)
});
export { settings_tickets_closed_notice as "settings.tickets.closed_notice" }